import type { DeliveryPopupMoodId } from './deliveryPopupMood';
import type { DeliveryPopupTail } from './deliveryPopupLayout';
import './DeliveryPopupEmoji.css';

import goodMoodEmoji from '../../../../map_screen/delivery_popup/emoji/good_mood_emoji.png';
import normalMoodEmoji from '../../../../map_screen/delivery_popup/emoji/normal_mood_emoji.png';
import notNormalMoodEmoji from '../../../../map_screen/delivery_popup/emoji/not_normal_mood_emoji.png';
import badMoodEmoji from '../../../../map_screen/delivery_popup/emoji/bad_mood_emoji.png';
import veryBadMoodEmoji from '../../../../map_screen/delivery_popup/emoji/very_bad_mood_emoji.png';

/** Where the emoji badge should be anchored (relative to the delivery-popup root). */
const DELIVERY_POPUP_EMOJI_ANCHOR = {
  left: 0,
  top: 0,
} as const;

const EMOJI_ASSET_BY_MOOD: Record<DeliveryPopupMoodId, string> = {
  good_mood: goodMoodEmoji,
  normal_mood: normalMoodEmoji,
  not_normal_mood: notNormalMoodEmoji,
  bad_mood: badMoodEmoji,
  very_bad_mood: veryBadMoodEmoji,
};

function getDeliveryPopupEmojiSize(moodId: DeliveryPopupMoodId): { width: number; height: number } {
  // Images are designed with different heights for some moods.
  switch (moodId) {
    case 'not_normal_mood':
      return { width: 105, height: 136 };
    default:
      return { width: 105, height: 105 };
  }
}

/** Tail-up backgrounds are emoji-less; overlay the dedicated badge art. */
export function shouldShowDeliveryPopupEmoji(tail: DeliveryPopupTail): boolean {
  return tail === 'up';
}

type DeliveryPopupEmojiProps = {
  moodId: DeliveryPopupMoodId;
  tail: DeliveryPopupTail;
};

/** Mood emoji badge for tail-up popups. */
export function DeliveryPopupEmoji({ moodId, tail }: DeliveryPopupEmojiProps) {
  void tail; // emoji is always the same overlay; tail kept for API symmetry
  const { left, top } = DELIVERY_POPUP_EMOJI_ANCHOR;
  const assetUrl = EMOJI_ASSET_BY_MOOD[moodId];
  const size = getDeliveryPopupEmojiSize(moodId);

  return (
    <div
      className="delivery-popup__emoji"
      style={{
        left,
        top,
        width: size.width,
        height: size.height,
      }}
    >
      <img
        className="delivery-popup__emoji-img"
        src={assetUrl}
        alt=""
        draggable={false}
        aria-hidden
        style={{
          width: size.width,
          height: size.height,
        }}
      />
    </div>
  );
}
